import { call, takeLatest, all } from 'redux-saga/effects';

import { getNews, createNews, editNews, deleteNews } from 'api/news';
import { NEWS_ACTION_TYPES } from 'store/actions/news.actions';
import { NOT_PUBLISHED } from 'config/news';

function* loadNewsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getNews, payload);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e);
  }
}

function* createNewsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(createNews, {
      ...payload,
      status: NOT_PUBLISHED,
      language: `/languages/${payload.language}`,
    });
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editNewsFlow(action) {
  const { payload, resolve, reject } = action;
  const { id, ...data } = payload;
  try {
    const { data: response } = yield call(editNews, id, { ...data, language: `/languages/${data.language}` });
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteNewsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(deleteNews, payload);
    resolve(response);
  } catch (e) {
    reject(e);
  }
}

function* watchLoadNews() {
  yield takeLatest(NEWS_ACTION_TYPES.LOAD_NEWS, loadNewsFlow);
}

function* watchCreateNews() {
  yield takeLatest(NEWS_ACTION_TYPES.CREATE_NEWS, createNewsFlow);
}

function* watchEditNews() {
  yield takeLatest(NEWS_ACTION_TYPES.EDIT_NEWS, editNewsFlow);
}

function* watchDeleteNews() {
  yield takeLatest(NEWS_ACTION_TYPES.DELETE_NEWS, deleteNewsFlow);
}

export default function* () {
  yield all([watchLoadNews(), watchCreateNews(), watchEditNews(), watchDeleteNews()]);
}
